<script setup lang="ts">

const props = withDefaults(defineProps<{
    variant?: 'small' | 'large',
    outline?: boolean
}>(), {
    variant: 'small',
    outline: false
})

</script>
<template>
    <div :class="{
        'lan:block lan:rounded-[10px] lan:bg-[#c63835] lan:px-[5px] lan:py-0.5 lan:box-border lan:font-bold lan:text-center lan:text-white': true,
        'lan:min-w-4 lan:h-5 lan:text-[14px] lan:leading-[18px]': props.variant === 'large',
        'lan:min-w-2.5 lan:h-4 lan:text-[12px] lan:leading-3.5': props.variant === 'small',
        'lan:outline-white lan:outline-2': props.outline
    }">
        <slot></slot>
    </div>
</template>